import { useEffect, useSyncExternalStore } from "react";
import {
  freshenStageList,
  stageListSnapshot,
  subscribeStageList,
  watchStageList,
  type StageList,
} from "@/features/order-instructions/lib/stage-list";

export function useStageList(): StageList {
  const list = useSyncExternalStore(subscribeStageList, stageListSnapshot, stageListSnapshot);
  useEffect(() => watchStageList(), []);
  return list;
}

export function usePrefetchedStageList(): StageList {
  const list = useSyncExternalStore(subscribeStageList, stageListSnapshot, stageListSnapshot);
  useEffect(() => freshenStageList(), []);
  return list;
}
